var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatOccupied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.81,
    height: 32.9,
    viewBox: "0 0 30.81 32.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:none;stroke:#bfcad0;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seat",
    transform: "translate(1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1898",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.973 0h11.471C21 0 23.877 3.167 23.877 7.074v22.315H0V7.074C0 3.167 2.421 0 5.973 0z",
    transform: "translate(2.21)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfcad0",
    d: "M5.973 2.5C3.693 2.5 2.5 4.8 2.5 7.074v19.815h18.877V7.074c0-2.522-1.764-4.574-3.933-4.574H5.974m0-2.5h11.47c3.553 0 6.433 3.167 6.433 7.074v22.315H0V7.074C0 3.167 2.42 0 5.973 0z",
    transform: "translate(2.21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    fill: "none",
    stroke: "#bfcad0",
    strokeLinejoin: "round",
    strokeWidth: "2.5px",
    d: "M828.731 392.82v14.419h28.31V392.82",
    transform: "translate(-828.731 -375.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    d: "M0 0L10 10",
    className: "cls-3",
    transform: "translate(9.148 9.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232",
    d: "M10 0L0 10",
    className: "cls-3",
    transform: "translate(9.148 9.694)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatOccupied);
export default __webpack_public_path__ + "static/media/seat-occupied.7e3cde6862120b19aa8b720d9d0793e7.svg";
export { ForwardRef as ReactComponent };